export default [
  {
    path: '/main/users',
    meta: {
      tag: 'list_user',
      name: 'Usuários',
      breadcrumb: 'Usuários'
    },
    component: () => import(/* webpackChunkName: "users-list" */ '@/views/main/settings/users/users/Index.vue'),
    children: [
      {
        path: '',
        name: 'listusers',
        meta: {
          tag: 'list_user',
          menu: 'settings',
          name: 'Usuários'
        },
        component: () => import(/* webpackChunkName: "os-list" */ '@/views/main/settings/users/users/List.vue')
      },
      {
        path: '/main/users/add',
        name: 'addusers',
        meta: {
          tag: 'add_user',
          menu: 'settings',
          name: 'Adicionar | Usuário',
          breadcrumb: 'Adicionar Usuário'
        },
        component: () => import(/* webpackChunkName: "users-add" */ '@/views/main/settings/users/users/Add.vue')
      },
      {
        path: '/main/users/:id',
        name: 'edituser',
        meta: {
          tag: 'edit_user',
          menu: 'settings',
          name: 'Editar | Usuário',
          breadcrumb: 'Editar Usuário'
        },
        component: () => import(/* webpackChunkName: "users-edit" */ '@/views/main/settings/users/users/Edit.vue')
      }
    ]
  }
]